import { sortAscending } from "utils/";

export function getTagsAsList(tagsObject = {}) {
  if (!tagsObject || typeof tagsObject !== "object") {
    return [];
  }

  return Object.values(tagsObject).sort((a, b) => {
    const aName = a.name && a.name.toLowerCase();
    const bName = b.name && b.name.toLowerCase();
    return sortAscending(aName, bName);
  });
}

export function getTagNamesFromTagsList(tagsList = []) {
  return tagsList.map(tag => {
    return tag.name;
  });
}

export function isTagNameUnique(tagName, tags) {
  const tagsList = getTagsAsList(tags);
  const tagNames = getTagNamesFromTagsList(tagsList);

  return !tagNames.includes(tagName);
}
